export default {
  MAX_NUMCOLS: 8,
  isRegister: (viewField = {}) => viewField && viewField.properties && !!viewField.properties.length,
  isArray,
  // devuelve la ultima parte de una cadena "str" separada por "separador" por defecto:".".
  getLastItem: (str = '', separator = '.') => str.split(separator).slice(-1)[0],
  // devuelve la ultima parte de una cadena "str" separada por "separador" por defecto:".".
  getLastItems: (str = '', num = 1, separator = '.') =>
    str
      .split(separator)
      .slice(-1 * num)
      .join(separator),
  setAttribute: setAttribute,
  escapeQuotes: escapeQuotes,
  getRegister, // para un string "CAB.LIN.DATA" return "LIN"
  shortModel, // de 'CAB.EMB.LIN.IDLIN' => 'LIN.IDLIN'
  // devuelve el padre. getParent('CAB.LIN.DESTINO') => 'CAB.LIN'
  getParent: (model = '') =>
    model
      .split('.')
      .slice(0, -1)
      .reduce(function(acc, cur) {
        return acc + (acc && cur ? '.' : '') + cur;
      }, ''),
  isExpression: exp => (typeof exp === 'string' || typeof exp === 'boolean') && exp !== '',
  isNotDefaultExpression: (exp, defaultExp) => isExpression(exp) && exp !== defaultExp,
  getRelativeModel, // (model, parentModel) => el model hasta el parent, ej: // (CAB.LIN.ID, CAB.LIN) => LIN.ID
};

// /////////////////////////////

/**
 * Devuelve true si el viewField es un array
 * @param {object} viewField
 * @return {boolean}
 */
function isArray(viewField) {
  // odeniel => viewField.max esta DEPRECATED. Lo dejamos por retrocompatibilidad
  const max = viewField.max || (viewField.metadata || {}).max;
  if (typeof max === 'number' && max > 1) {
    return true;
  }
  if (viewField.type === 'array' || viewField.type === 'list') {
    // por segurida, porque en el grid se puede crear arrays sin max
    return true;
  }
  return false;
}

function setAttribute(name, value, onlyIfNotEmpty, quote) {
  if (onlyIfNotEmpty && !value) {
    if (typeof onlyIfNotEmpty !== 'boolean') {
      console.error('DEPRECATED - onlyIfNotEmpty = quote???');
    }
    return '';
  }
  value = value || '';
  var q = quote || '"';
  return ` data-${name}=${q}${value}${q} `;
}

function escapeQuotes(data) {
  if (typeof data === 'string') {
    return escapeQuotesInString(data);
  }
  for (var i in data) {
    data[i] = escapeQuotes(data[i]);
  }
  return data;

  // /////////////////////

  function escapeQuotesInString(str) {
    return str.replace(/'/g, "\\'").replace(/"/g, '\\"');
  }
}

function getRegister(model) {
  var t = model.split('.');
  var len = t.length;
  if (len > 1) {
    return t[len - 2];
  }
  console.error(`Error calling getRegister(${model}).`);
}

function shortModel(model) {
  var t = model.split('.');
  var len = t.length;
  return `${t[len - 2]}.${t[len - 1]}`;
}

function getRelativeModel(model, parent = '') {
  const splitted = model.split('.'),
    index = splitted.findIndex(item => item === parent) || 0;
  return splitted.slice(index - 1).join('.');
}
